import type { Directive } from "vue";

export const disableAll: Directive<HTMLElement, boolean> = {
  mounted(el, binding) {
    applyDisable(el, binding.value);
  },
  updated(el, binding) {
    applyDisable(el, binding.value);
  },
};

function applyDisable(el: HTMLElement, isDisabled: boolean) {
  const tags = ["input", "button", "textarea", "select"] as const;

  tags.forEach((tagName) => {
    const nodes = el.getElementsByTagName(tagName);
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i] as
        | HTMLInputElement
        | HTMLButtonElement
        | HTMLTextAreaElement
        | HTMLSelectElement;

      node.disabled = isDisabled;
      node.tabIndex = isDisabled ? -1 : 0;
    }
  });

  const vuetifyComponents = el.querySelectorAll(
    ".v-select, .v-text-field, .v-input, .v-switch, .v-btn, .v-chip-group"
  );

  vuetifyComponents.forEach((component) => {
    if (isDisabled) {
      component.classList.add("v-input--disabled", "v-input--is-disabled");
    } else {
      component.classList.remove("v-input--disabled", "v-input--is-disabled");
    }

    const input = component.querySelector("input, textarea, select, button") as
      | HTMLInputElement
      | HTMLTextAreaElement
      | HTMLSelectElement
      | HTMLButtonElement
      | null;

    if (input) {
      input.disabled = isDisabled;
    }

    const menu = component.querySelector(".v-menu");
    if (menu) {
      if (isDisabled) {
        menu.classList.add("v-menu--disabled");
      } else {
        menu.classList.remove("v-menu--disabled");
      }
    }
  });
}
